import { useState } from 'react';

import { Button, Col, Modal, Row } from 'antd';
import { useDispatch } from 'react-redux';
import { useSendCommitteeControlDecisionMutation } from 'services';
import { fetchError } from 'slices/commonSlice';
import { committeeDecisions, openNotification } from 'utils';

/**
 * Heytetin maddeyi madde sorumlusundangeri cekmesi icin gereken alana ulasmasini saglar
 * @param {number} offerId - offer id
 * @returns {React.ReactNode}
 */

function RevertFormSupervisor({ offerId }) {
  const [sendCommitteeControlDecision] = useSendCommitteeControlDecisionMutation();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const handleRevert = async () => {
    const { error } = await sendCommitteeControlDecision({
      id: offerId,
      committee: 'owner_committee',
      body: {
        status: committeeDecisions.revert,
      },
    });
    if (error) {
      return dispatch(fetchError(error.message));
    }
    setOpen(false);
    openNotification({
      message: 'Madde sorumlusundan geri çekildi.',
    });
  };

  return (
    <>
      <Row gutter={24}>
        <Col className="modalBtnGrp gx-w-100">
          <div className="gx-d-flex gx-flex-column gx-align-items-center gx-align-items-center gx-w-100">
            <Button
              block
              size="large"
              onClick={() => setOpen(true)}
            >
              MADDDE SORUMLUSUNDAN GERİ ÇEK
            </Button>
          </div>
        </Col>
      </Row>
      <Modal
        title="Madde Sorumlusundan Geri Çekilecek?"
        destroyOnClose
        open={open}
        okText="Evet"
        cancelText="Hayır"
        onOk={handleRevert}
        onCancel={() => setOpen(false)}
      >
        Onayladığınızda madde <strong>TS - İH Madde Kontrol</strong> durumuna dönecektir.
      </Modal>
    </>
  );
}
export default RevertFormSupervisor;
